// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const BoxCount = styled.span<{ isDark?: boolean }>(
  ({ theme, isDark }) => css`
    padding: 2px 7px;
    background-color: ${
      isDark ? theme.colors.gray['lighter-dark-mode'] : theme.colors.gray.light
    };
    color: ${isDark ? theme.colors.white : theme.colors.base.main};
    border-radius: 5px;
  `,
);

export const AttrWrapper = styled.div<{ isDark?: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 16px;
    padding: 6px 32px 26px 32px;
    color: ${isDark ? theme.colors.white : theme.colors.gray.dark};
    background-color: ${
      isDark ? theme.colors.base.main : theme.colors.gray.lighter
    };
    .icon {
      color: ${isDark ? theme.colors.base.lighter : theme.colors.gray.main};
    }
  `,
);
